import UnprotectedNoMatch from '../components/v4/UnprotectedNoMatch';
import ActivateAccount from '../pages/auth/new/ActivateAccount';
import { PartnerTrial } from '../pages/partner-trial';
import MSRedirect from 'pages/auth/new/sso/redirect';

import Auth from '@/v5/components/pages/auth';

export default [
    {
        path: '/',
        element: <Auth />,
    },
    {
        path: '/register',
        element: <Auth />,
    },
    {
        path: '/forgot-password',
        element: <Auth />,
    },
    {
        path: '/change-password',
        element: <Auth />,
    },
    {
        path: '/activate',
        element: <ActivateAccount />,
    },
    {
        path: '/partnertrial',
        element: <PartnerTrial />,
    },
    {
        path: '/sso/ms/redirect',
        element: <MSRedirect />,
    },
    { path: '*', element: <UnprotectedNoMatch /> },
];
